import React, { useContext } from 'react';
import { isBrowser } from '@firsttable/functions';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import Experiment from '@components/analytics/experiments/experiment';
import {
  PD6699_MODERNISE_HOMEPAGE_SIGNUP_FLAG,
  PD6699SignupModal,
} from '@components/analytics/experiments/PD6699ModerniseHomepageSignup';
import OAuthProviders from './OAuthProviders';
import AuthLayout from './AuthLayout';
import SilverstripeContext from '../../context/Silverstripe';
import { useModal } from '../../context/ModalContext';

type SignUpLayoutProps = {
  isModal?: boolean;
  cityId?: any;
  inviteCode?: string;
  email?: string | null;
  children?: React.ReactNode;
};

const SignUpLayout = ({ cityId: providedCityId, ...props }: SignUpLayoutProps) => {
  const { page } = useContext(SilverstripeContext);
  const { isModalOpen } = useModal();
  const cityId = providedCityId || page?.regionId;

  return (
    <TrackProvider
      pageEventName="account_creation_page_viewed"
      source_page="sign up"
      page_type="modal"
      eventParams={{
        page_action: 'account creation',
        promo_code: isBrowser ? new URLSearchParams(window.location.search).get('code') : undefined,
        promo_code_used: isBrowser && !!new URLSearchParams(window.location.search).get('code'),
        email: isBrowser ? new URLSearchParams(window.location.search).get('email') : undefined,
      }}>
      <div>
        <Experiment
          flag={PD6699_MODERNISE_HOMEPAGE_SIGNUP_FLAG}
          eligible={isModalOpen}
          control={
            <AuthLayout signUp>
              <OAuthProviders {...props} cityId={cityId} />
            </AuthLayout>
          }
          treatment={<PD6699SignupModal email={props.email} />}
        />
      </div>
    </TrackProvider>
  );
};

export default SignUpLayout;
